import {
  BaseSyntheticEvent,
  cloneElement,
  lazy,
  Suspense,
  useState,
} from 'react';

import { TJobLogsDrawerProps } from '@/console/features/jobs/components/job-logs-drawer/job-logs-drawer.types';

const JobLogsDrawerContent = lazy(() =>
  import('@/console/features/jobs/components/job-logs-drawer/job-logs-drawer').then(
    (module) => ({ default: module.JobLogsDrawer }),
  ),
);

// For the status chips on the home cards: the drawer's diff view and markdown reader
// are not on the sign-in path, but the chip must show before that chunk arrives.
// React starts the import as this renders, so the wait is only the download — but a
// click landing inside it would hit a trigger that DrawerController has not injected
// its handler into yet, so remember it and open once the chunk resolves.
export const JobLogsDrawer = (props: TJobLogsDrawerProps) => {
  const { trigger, initialOpen } = props;
  const [clickedWhileLoading, setClickedWhileLoading] = useState(false);

  const fallbackTrigger = () => {
    const element = typeof trigger === 'function' ? trigger(false) : trigger;

    return cloneElement(element, {
      onClick: (event: BaseSyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setClickedWhileLoading(true);
      },
    });
  };

  return (
    <Suspense fallback={fallbackTrigger()}>
      <JobLogsDrawerContent
        {...props}
        initialOpen={initialOpen || clickedWhileLoading}
      />
    </Suspense>
  );
};
